import React from 'react'

import { SxProps, Theme } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import colors from '@/assets/scss/_themes-vars.module.scss'

export type ContentHeaderProps = {
  /**
   * The title content
   */
  title: string
  /**
   * The sub title content
   */
  subtitle?: string
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * See the [`sx` page](https://mui.com/system/the-sx-prop/) for more details.
   */
  sx?: SxProps<Theme>
}

export function ContentHeader(props: ContentHeaderProps) {
  const { title, subtitle, sx } = props

  return (
    <Stack sx={sx} direction="row" justifyContent="space-between" alignItems="stretch" spacing={2}>
      <Stack>
        <Typography variant="h3" sx={{ color: colors.gray900, fontSize: '18px', fontWeight: 500, lineHeight: '24px', mb: '4px' }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="subtitle1" component="p" sx={{ color: colors.gray500, fontSize: '14px', lineHeight: '20px' }}>
            {subtitle}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}

export default ContentHeader